<template>
    <div class="container">
        <div class="row">
            <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
               Current Company Members
            </div>
            <div v-for="(member) in showsData" :key="member.id"
                class="col-md-3 d-flex flex-column align-items-center justify-content-start pb-3 px-sm-2 px-5 ">

                <img :src="`${$API_ASSETS}${member.headshot.id}.png`" class="img-fluid py-2 w-100 px-2" />
                <div class="text-start px-3">
                    <span class="fs-3 text-uppercase oswald-bold">{{ member.name }}</span>
                    <span class="fs-6 d-block open-sans">{{ member.bio }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'MembersSection',
    data() {
        return {
            showsData: [],
        };
    },
    methods: {
        async fetchShowData() {
            const url = this.$API_GRAPHQL;
            try {
                const response = await axios.post(url, {
                    query: `
                       query {
                            company_member(filter:{ hidden:{_eq:false}}) {
                                id
                                initials
                                name
                                bio
                                headshot {
                                    id
                                }
                            }
                        }
                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });

                // Corrected Data Path
                this.showsData = response.data.data.company_member.sort((a, b) =>  a.name.localeCompare(b.name));
                console.log('Fetched Data:', this.showsData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    },
    created() {
        this.fetchShowData();
    }
};

</script>
